import { IExaminationDataValue } from "@/models/ExaminationDataValue";

const normalizeExaminationValueDate = (
  examination: IExaminationDataValue
): IExaminationDataValue => {
  return examination.Time.at(-1) === "Z"
    ? { ...examination, Time: examination.Time.slice(0, -1) }
    : {
        ...examination,
        Time: examination.Time,
      };
};

export default normalizeExaminationValueDate;
